/**
 * What the docs pages' shared pieces take: tag pills, a row of action links
 * styled as buttons, and the card that pairs them with a title and a
 * description (the markup is in `page-elements.tsrx`). Actions are links, not
 * buttons, because each one goes somewhere: a route link is followed by the
 * router, an asset opens as a document, and a new-tab link says so to screen
 * readers.
 */
import type { ButtonProps } from '@crown/ui/button';

export interface ActionLink {
  readonly label: string;
  readonly href: string;
  readonly variant?: ButtonProps['variant'];
  readonly newTab?: boolean;
}

export interface DocsCardConfig {
  readonly eyebrow?: string;
  readonly title: string;
  readonly description: string;
  readonly tags: readonly string[];
  readonly actions: readonly ActionLink[];
}

const assetHrefPattern = /\.(?:svg|png|mmd|md|json)$/i;

/** A path inside the app the router shows, rather than a file served beside it. */
export function isRouteHref(href: string): boolean {
  return (
    href.startsWith('/') &&
    !href.startsWith('/explorer/') &&
    !href.startsWith('/diagrams/') &&
    !href.startsWith('/content/') &&
    !assetHrefPattern.test(href)
  );
}
